const AperetivMass=[
    {
        id:1,
        title:"Кампарі (Італія) 1л",
        price:"1700 грн",
        src: require('../img/campary.webp'),
        text:"50мл - 85 грн",
    },
    {
        id:2,
        title:"Апероль (Італія) 1л",
        price:"1700 грн",
        src: require('../img/aperol.webp'),
        text:"50мл - 85 грн",
    },
    {
        id:3,
        title:"Ксента Абсента (Італія) 1л",
        price:"2100 грн",
        src: require('../img/xenta.webp'),
        text:"50мл - 105 грн",
    },
    
    
]

export default AperetivMass;